import React, { PropsWithChildren } from "react"

type FallbackProvidedSkeletonProps = PropsWithChildren<{
	isLoading: boolean
	skeleton: React.ReactNode
}>

export const FallbackProvidedSkeleton: React.FC<FallbackProvidedSkeletonProps> = ({ isLoading, skeleton, children }) => {
	if (isLoading) {
		return <>{skeleton}</>
	}

	return <>{children}</>
}
